import axios from "axios";
import config from "../config";
import type { ApiSuccess } from "./api_helper";

const apiBase = config.api.API_URL;

export type TenantRole = "owner" | "editor" | "approver";

export type TeamMember = {
  id: number;
  name: string;
  email: string;
  roles?: TenantRole[];
  role?: TenantRole;
  created_at?: string | null;
};

export type TeamInvite = {
  id: number;
  email: string;
  role: Exclude<TenantRole, "owner">;
  expires_at?: string | null;
  created_at?: string | null;
};

export const getTeamMembers = (): Promise<ApiSuccess<TeamMember[]>> =>
  axios.get(apiBase + "/team/members");

export const getTeamInvites = (): Promise<ApiSuccess<TeamInvite[]>> =>
  axios.get(apiBase + "/team/invites");

export const inviteTeamMember = (payload: {
  email: string;
  role: Exclude<TenantRole, "owner">;
}): Promise<ApiSuccess<TeamInvite>> =>
  axios.post(apiBase + "/team/invites", payload);

export const updateTeamMemberRole = (
  id: number,
  role: Exclude<TenantRole, "owner">
): Promise<ApiSuccess<TeamMember>> =>
  axios.patch(`${apiBase}/team/members/${id}`, { role });

export const removeTeamMember = (id: number): Promise<ApiSuccess<null>> =>
  axios.delete(`${apiBase}/team/members/${id}`);

export const revokeTeamInvite = (id: number): Promise<ApiSuccess<null>> =>
  axios.delete(`${apiBase}/team/invites/${id}`);

export const acceptTeamInvite = (payload: {
  token: string;
  name: string;
  password: string;
}): Promise<ApiSuccess<{ id: number }>> =>
  axios.post(apiBase + "/team/invites/accept", payload);
